module.exports = __webpack_public_path__ + "static/media/convertir_artista_linea_2.f0289111.svg";